module.exports = __webpack_public_path__ + "img/2c37284c6eb81dd050ec52b6252870fa.jpg";